module.exports = __webpack_public_path__ + "img/LUB00360.410cf5cf.png";